import React, { type JSX } from 'react'
import classNames from 'classnames'
import SvgLogIn from '../../svg/log-in.svg'
import { IconProps } from '../icon-props'

const LogInIcon = ({
  className = '',
  multiLayered = false,
  ...props
}: IconProps): JSX.Element | null => (
  <SvgLogIn
    {...props}
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    className={classNames('i-login', className, {
      'i-multi-layered': multiLayered,
    })}
  />
)

export default LogInIcon
